import { ITipoUnidade } from '../../../types/tables/ITipoUnidade';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * Serviço para gerenciamento de unidades de medida com isolamento multi-tenant
 * Gerencia tipos de unidades para produtos (Un, Kg, Litro, etc.)
 */
export class TipoUnidadeService extends BaseMultiTenantService<ITipoUnidade> {
     constructor() {
          super(
               'tipo_unidade', 
               ['descricao'],
               'fk_id_organizacao'
          );
     }

     /**
      * Busca unidades que requerem controle de estoque
      */
     async getUnidadesComControleEstoque(organizationId: number) {
          return await this.client
               .from('tipo_unidade')
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('req_ctrl_estoque', true)
               .is('deleted_at', null)
               .order('descricao');
     }

     /**
      * Busca unidades por quantidade mínima
      */
     async getByQuantidadeMinima(organizationId: number, qtdMin: number) {
          return await this.client
               .from('tipo_unidade')
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .gte('qtd_min', qtdMin)
               .is('deleted_at', null)
               .order('qtd_min');
     }
}
